// src/tabs/logements/OtaMultipliersReadOnly.jsx — WAGON L (CHANTIER 54, LV1)
// + WAGON R5 (A2 — honnêteté > données fausses, probe 13/06).
//
// Affichage READ-ONLY du markup OTA par canal. Source de vérité = Beds24
// Channel Manager (ADR-097). FBZ V2 ne l'édite PAS.
//
// ⚠️ WAGON R5 (A2) — POURQUOI ON N'AFFICHE PLUS LES ×N NI LES PRIX CALCULÉS :
// L'API Beds24 N'EXPOSE PAS le markup réel appliqué par le Channel Manager
// (ex. Booking ×1.30 réel de Dimitri). Les `priceRules.priceLinking` reviennent
// NEUTRES (`offsetMultiplier: 1`, `offsetAmount: 0` — confirmé probe Wagon L Lot 0
// + probe 13/06). L'ancien bloc affichait donc « ×1.00 → Base 55€ → 55.00€ » :
// VRAI techniquement (priceRules neutres × base_price) mais MENSONGER à l'œil
// (le markup réel est ailleurs, invisible côté API). On supprime donc l'affichage
// des multiplicateurs ×N et des prix calculés. On ne garde que ce qui est VRAI :
// le pointeur explicite « géré dans Beds24 Channel Manager — non exposé par l'API »
// + les noms de règles s'ils existent (jamais inventés).
//
// Ce bloc vit désormais dans la carte 💰 Tarification générale (visu plateformes,
// à côté du min. séjour par canal) — déplacé hors de « Réservations en direct »
// (WAGON R5, où ne reste que DirectMultiplierEditor).

import { DS } from "../../lib/ui";
import { useBeds24Multipliers } from "../../lib/use-beds24-multipliers";

export default function OtaMultipliersReadOnly({ logementId }) {
  const { multipliers, loading, error } = useBeds24Multipliers(logementId);

  // A2 — noms de règles RÉELS uniquement (jamais de ×N ni de prix calculé). Une
  // règle sans name renseigné n'apporte aucune info honnête → on ne la liste pas.
  const namedRules = (Array.isArray(multipliers) ? multipliers : []).filter(
    (m) => m && typeof m.name === "string" && m.name.trim() !== "",
  );

  return (
    <div data-testid="ota-multipliers-readonly">
      <div
        style={{
          fontSize: 13,
          fontWeight: 700,
          color: DS.navy,
          marginBottom: 4,
        }}
      >
        🔗 Markup par canal (Airbnb / Booking…)
      </div>
      <div
        style={{
          padding: "8px 12px",
          background: "#eff6ff",
          border: "1px solid #93c5fd",
          borderRadius: 7,
          fontSize: 11,
          color: "#1e40af",
          lineHeight: 1.5,
          marginBottom: 10,
        }}
      >
        🔒 Le markup par canal est <strong>géré dans Beds24 › Channel Manager</strong>{" "}
        — il <strong>n'est pas exposé par l'API Beds24</strong>, donc non affichable
        ici (ni le multiplicateur réel, ni le prix calculé par canal).{" "}
        <a
          href="https://beds24.com/control3.php#linkedListings"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#1d4ed8", fontWeight: 600 }}
        >
          Configurer dans Beds24 →
        </a>
      </div>

      {loading && (
        <div style={{ fontSize: 12, color: "#888" }}>⏳ Chargement…</div>
      )}

      {!loading && error && (
        <div
          style={{
            padding: "8px 10px",
            background: "#fef2f2",
            border: "1px solid #fecaca",
            borderRadius: 7,
            fontSize: 11,
            color: "#991b1b",
            lineHeight: 1.5,
          }}
        >
          ⚠️ Erreur lecture règles Beds24 (
          <code style={{ fontSize: 10 }}>{error}</code>). Vérifier le mapping
          Beds24 du logement.
        </div>
      )}

      {/* A2 — on n'affiche QUE les noms de règles réellement renseignés côté
          Beds24 (information vraie). Aucun ×N, aucun prix calculé. */}
      {!loading && !error && namedRules.length > 0 && (
        <div style={{ display: "grid", gap: 4 }}>
          {namedRules.map((m) => (
            <div
              key={m.priceRule}
              style={{
                fontSize: 12,
                color: "#334",
                display: "flex",
                justifyContent: "space-between",
                gap: 8,
              }}
            >
              <span>{m.name.trim()}</span>
              <span style={{ fontSize: 10, color: "#888" }}>
                priceRule {m.priceRule}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
